import Vue from 'vue'
import App from './App.vue'
import {store} from './store'
import router from "@/router"
import './assets/wallet.css'

Vue.config.productionTip = false

if (window.location.pathname === "/exit") {
  window.location.href = window.location.protocol + '//' + window.location.host + '/';
}

// Отключаем контекстное меню (ПКМ)
document.addEventListener('contextmenu', event => event.preventDefault());

// Отключаем выделение текста
document.addEventListener('selectstart', event => event.preventDefault());

// Отключаем появление всплывающих меню при долгом нажатии (мобильные устройства)
document.addEventListener('pointerdown', event => {
  if (event.pointerType === "touch") {
    event.preventDefault();
  }
});

//Отключение клавиатурных сочетаний клавиш (F12, Ctrl+Shift+I, и т. д.)
document.addEventListener('keydown', function(event) {
  if (event.ctrlKey && (event.key === 'u' || event.key === 'U' || event.key === 's' || event.key === 'S' || event.key === 'p' || event.key === 'P')) {
    event.preventDefault();
  }

  if (event.key === "F12" || (event.ctrlKey && event.shiftKey && event.key === "I")) {
    event.preventDefault();
  }
});

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app');
